import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "Personal__Training",
  class: "d-flex"
}
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("section", { class: "ms-auto card-heading-options" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.axxess.com/on_demand/",
    class: "heading-option flex-row py-2 my-n1",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-video" }),
    /*#__PURE__*/_createElementVNode("span", { class: "text ms-1" }, "More Training Videos")
  ])
], -1 /* HOISTED */)
const _hoisted_4 = { class: "mt-3 text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" }, null, -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Loading Video", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" }, null, -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "mt-5 text-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" There was a problem while fetching the video. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Please try again. ")
], -1 /* HOISTED */)
const _hoisted_11 = { class: "w-100 h-100" }
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardTemplate = _resolveComponent("CardTemplate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CardTemplate, null, {
      header: _withCtx(() => [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_ctx.videoData?.Title), 1 /* TEXT */)
        ]),
        _hoisted_3
      ]),
      content: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_4, _hoisted_8, 512 /* NEED_PATCH */), [
          [_vShow, _ctx.isLoading && !_ctx.hasError]
        ]),
        _createCommentVNode(" ERROR "),
        _withDirectives(_createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getVideo && _ctx.getVideo(...args)))
          }, "Try Again")
        ], 512 /* NEED_PATCH */), [
          [_vShow, _ctx.hasError && !_ctx.isLoading]
        ]),
        _createCommentVNode(" DATA "),
        _withDirectives(_createElementVNode("div", _hoisted_11, [
          _createElementVNode("section", {
            class: "personal-training-video w-100 h-100",
            innerHTML: _ctx.videoData?.Text
          }, null, 8 /* PROPS */, _hoisted_12)
        ], 512 /* NEED_PATCH */), [
          [_vShow, !_ctx.isLoading && !_ctx.hasError && _ctx.videoData]
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}